module.exports = __webpack_public_path__ + "img/dapper.4ba3627a.png";